module.exports = __webpack_public_path__ + "static/gradient_3-c246127f9e8d9512ef91d9bbd65b39b5.png";